import { render, staticRenderFns } from "./ClickableText.vue?vue&type=template&id=55f6b793"
import script from "./ClickableText.vue?vue&type=script&lang=js"
export * from "./ClickableText.vue?vue&type=script&lang=js"
import style0 from "./ClickableText.vue?vue&type=style&index=0&id=55f6b793&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports